module.exports = __webpack_public_path__ + "img/team_edgaras_slezas.d3217394.webp";